<template>
    <v-layout row justify-center>
        <v-dialog scrollable v-model="showConversationDialog" persistent max-width="1088px" content-class="fti-dialog-conversation-history-picker">
            <v-card ref="form">
                <div class="fti-dialog-header pl-2">
                    <span class="headline " v-if="dialogConversationHistory.chatLogs">
                        {{ $t('conversationHistory')|capitalize }}
                    </span>
                    <span v-else-if="dialogConversationHistory.sessionId">
                        {{ $t('supportedBy')|capitalize }}:
                        {{ dialogConversationHistory.user ? dialogConversationHistory.user.email : '' }} -
                        {{ dialogConversationHistory.updated ? formatDateTime(dialogConversationHistory.updated) : '' }}
                    </span>
                    <v-spacer></v-spacer>
                    <v-btn flat icon @click="toggleConversationDialog">
                        <v-icon color="#fff">mdi-close</v-icon>
                    </v-btn>
                </div>
                <div class="chatview-content" ref="content">
                    <div id="loading" v-if="loading">
                        <v-progress-circular
                                :size="20"
                                :width="2"
                                color="green"
                                indeterminate
                        ></v-progress-circular>
                    </div>
                    <div>
                        <div class="msg-holder" v-for="msg in chatLog" :key="'msg_index_' + msg.id">
                            <div class="session_hr_time" v-if="msg.first_session">
                                <hr>
                                <span class="span-session">{{ formatDateTime(msg.created_time) }}</span>
                            </div>
                            <Message
                                    v-if="accept_message_types.includes(msg.type)"
                                    :message="msg"
                                    :customer="customer"
                                    :isLastSeenMsg="false"
                            ></Message>
                        </div>
                    </div>
                </div>
            </v-card>
        </v-dialog>
    </v-layout>
</template>

<script>
import {mapMutations, mapState} from "vuex";
import BotService from "@/services/bot.service";
import messageHandler from '@/services/message_handlers/supporter_handler_message.js';
import Message from "components/message-box/content/Message";
import utils from "@/services/utils";

const moment = require('moment');
    const ChatLogSource = {
        RECEIVE: 1,  // tin nhắn nhận từ người dùng
        SEND: 2,  // tin nhắn từ hệ thống gửi cho người dùng
    };
    const MessageSource = {
        NORMAL: 1,  // Tin nhắn bình thường ngời dùng vs bot, bot vs ng
        SYSTEM: 2,  // Tin nhắn từ hệ thống tới người dùng (broadcast) -> Deprecated
        ADMIN: 3,  // Admin gửi tin nhắn đến người dùng, người dùng chat với admin
        SEND_BROADCAST: 4,  // Send broadcast
        SEND_REMINDER: 5,  // Send reminder
        CALL_SEND_MESSAGE_API: 6,  // Send message controllers
    };
    export default {
        name: "DialogConversationHistory",
        components: {
            Message,
        },
        data () {
            return {
                loading: true,
                chatLog: [],
                accept_message_types: utils.viewableMessageType,
                shouldLoadChatLogOnScroll: false,
                paramsLoadChatLogs: '',
                canLoadMoreChatLogs: false,
            }
        },
        watch: {
            dialogConversationHistory: {
                handler () {
                    this.chatLog = [];
                    this.getConversationHistory();
                }
            }
        },
        beforeDestroy () {
            if (this.$refs.content) {
                this.$refs.content.removeEventListener('scroll', this.eventScrollChatlogs);
            }
        },
        mounted() {
            this.$nextTick(() => {
                let element = this.$refs.content;
                if (!element.hasAttribute('scroll')) {
                    element.addEventListener('scroll', this.eventScrollChatlogs);
                }
            });
        },
        computed: {
            ...mapState(['chatView']),
            ...mapState('dialog', ['showConversationDialog', 'dialogConversationHistory']),
            customer () {
                return {
                    name: this.chatView.customer.sender_name,
                    image: this.chatView.customer.image
                }
            },
        },
        methods: {
            ...mapMutations('dialog', ['toggleConversationDialog']),
            isUser (msg) {
                return msg.source === ChatLogSource.RECEIVE
            },
            isBot (msg) {
                return msg.sender_type !== MessageSource.ADMIN && msg.source === ChatLogSource.SEND
            },
            isAdmin (msg) {
                return msg.sender_type === MessageSource.ADMIN && msg.source === ChatLogSource.SEND
            },
            formatDateTime (time) {
                return moment(time).format('DD/MM/YYYY HH:mm')
            },
            handler_chatlog_msg (msg) {
                let acceptMsg = messageHandler.handler_message(msg, this.$store.getters.channel);
                acceptMsg.isLastMsg = true;
                let lengthMsg = this.chatLog.length;
                if (lengthMsg > 0) {
                    acceptMsg.isFirstMsg = acceptMsg.source !== this.chatLog[lengthMsg - 1].source
                    if (acceptMsg.source === this.chatLog[lengthMsg - 1].source) {
                        this.chatLog[lengthMsg - 1].isLastMsg = false;
                    }
                } else {
                    acceptMsg.isFirstMsg = true;
                }
                this.chatLog.unshift(acceptMsg);
            },
            async getConversationHistory (nextUrl = '') {
                let botCode = this.$route.params.bot_code;
                let senderId = this.$route.params.senderId;
                if (this.dialogConversationHistory.chatLogs) {
                    let chatLogs = this.sortChatLog(this.dialogConversationHistory.chatLogs);
                    for (let log of chatLogs) {
                        if (log.message_type !== "request_human_support" && log.message_type !== "typing") {
                            log.sender_type = log.type;
                            log.supporter = log.extra;
                            log.first_session = false;
                            let log_message = {...JSON.parse(log.message)}
                            for (let key of Object.keys(log_message)) {
                                if (key !== "source") {
                                    log[key] = log_message[key];
                                }
                            }
                        }
                        this.handler_chatlog_msg(log)
                    }
                    this.loading = false;
                    this.$nextTick(this.scrollBottom);
                    this.paramsLoadChatLogs = '';
                    this.canLoadMoreChatLogs = false;
                    this.shouldLoadChatLogOnScroll = false;
                }
                else if (this.dialogConversationHistory.sessionId) {
                    await BotService.getChatLogBySessionID(botCode, senderId, this.dialogConversationHistory.sessionId, nextUrl).then(
                        (res) => {
                            for (let log of res.data.chatlog) {
                                if (log.message_type !== "request_human_support" && log.message_type !== "typing") {
                                    log.sender_type = log.type;
                                    log.supporter = log.extra;
                                    log.first_session = false;
                                    let log_message = {...JSON.parse(log.message)}
                                    for (let key of Object.keys(log_message)) {
                                        if (key !== "source") {
                                            log[key] = log_message[key];
                                        }
                                    }
                                }
                                this.handler_chatlog_msg(log)
                            }
                            this.loading = false;
                            this.$nextTick(this.scrollBottom);
                            this.paramsLoadChatLogs = res.data.next ? res.data.next : '';
                            this.canLoadMoreChatLogs = this.paramsLoadChatLogs !== '';
                            this.shouldLoadChatLogOnScroll = true;
                        })
                }
            },
            scrollBottom () {
                let element = this.$refs.content;
                element.setAttribute('style', 'scroll-behavior: auto;');
                element.scrollTop = element.scrollHeight - element.clientHeight;
                element.setAttribute('style', 'scroll-behavior: smooth;');
            },
            sortChatLog(chatLogs) {
                chatLogs.sort(function (a, b) {
                    return b.created_time.localeCompare(a.created_time);
                });
                return chatLogs
            },
            async eventScrollChatlogs() {
                if (this.shouldLoadChatLogOnScroll) {
                    let objChatBox = this.$refs.content;
                    if (objChatBox.scrollTop === 0) {
                        if (this.canLoadMoreChatLogs) {
                            this.scrollPosition = objChatBox.scrollHeight;
                            this.loading = true;
                            await this.getConversationHistory(this.paramsLoadChatLogs);
                            this.$nextTick(function () {
                                this.loading = false;
                                // scroll
                                objChatBox.setAttribute('style', 'scroll-behavior: auto;');
                                objChatBox.scrollTop = objChatBox.scrollHeight - this.scrollPosition - 22;
                                objChatBox.setAttribute('style', 'scroll-behavior: smooth;');
                            });

                        }
                    }
                }
            },
        }
    }
</script>

<style scoped lang="scss" src="../style/conversation-history.scss"></style>
